import { Link } from "react-router-dom";
import SectionHeading from "@/components/base/SectionHeading";
import CastCard from "@/components/cards/CastCard";
import { castList } from "@/mocks/cast";

export default function CastShowcase() {
  const items = castList.slice(0, 4);

  return (
    <section className="bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-[1200px] px-4 md:px-6">
        <SectionHeading
          eyebrow="CAST"
          title="演员阵容"
          description="从少女到成熟，从沉默到释然，演员们用细腻的表演，为每一个角色注入了真实可感的温度。"
          action={
            <Link
              to="/cast"
              className="flex items-center gap-1 whitespace-nowrap rounded-md border border-primary-300 px-4 py-2 text-sm font-medium text-primary-700 transition-colors hover:bg-primary-50"
            >
              全部演员
              <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
            </Link>
          }
        />
        <div className="grid grid-cols-2 gap-4 md:gap-6 lg:grid-cols-4">
          {items.map((item) => (
            <CastCard key={item.id} item={item} />
          ))}
        </div>
      </div>
    </section>
  );
}